const MARKETVALUEMINIMUM = {
	MPCC: 400001,
	MPCCS: 400001,
	MCOC: 400001,
	MCOCS: 400001,
	MCPC: 400001,
	MUWC: 2500000,
	MUWCS: 2500000,
	MPRC: 3000000,
	MPRCS: 3000000,
	MLXC: 6000000,
	MLXCC: 6000000,
	MPPC: 500000,
	MPPCB: 500000,
	MPPCS: 500000,
	MPPCBS: 500000,
	MPPTF: 500000,
};

const ADDITIONALPREMIUMMINIMUM = {
	MPCCS: 2500,
  MPCTPS: 2500,
  MCOCS: 2500,
  MCOTPS: 2500,
  MPPCS: 20000,
  MPPTPS: 15000,
  MPPCBS: 25000,
  MPPTPBS: 20000,
  MPRC: 2500,
  MPRCC: 2500,
  MUWC: 2500,
  MUWCC: 2500,
  MLXC: 2500,
  MLXCC: 2500,
  MMCC: 2500,
  MMCTP: 2500,
  MPCC: 2500,
  MPCTP: 2500,
  MCOC: 2500,
  MCOTP: 2500,
  MCPC: 2500,
  MCPTP: 2500,
  MPPC: 20000,
  MPPTP: 15000,
  MPPCB: 25000,
  MPPTPB: 20000,
  MPPTF: 20000,
  MPPTFB: 25000,
  MPCTF: 2500
};

const TRANSWORDINGS = {
	DecreasedRefund: "Decrease Sum Insured - Refund Premium U.",
	DecreasedAdditional: "Decrease Sum Insured -Add't Premium U.",
	IncreasedRefund: "Increase Sum Insured - Refund U.",
	IncreasedAdditional: "Increase Sum Insured - Add't Premium U.",
};

const FILESNEEDED = {
	Valuation: "A Valuation Report (including photographs of the vehicle) for all comprehensive policies",
	Registration: "Motor Vehicle Registration",
};

export { MARKETVALUEMINIMUM, ADDITIONALPREMIUMMINIMUM, TRANSWORDINGS, FILESNEEDED };
